export const sizes = {
  container: 900,
  sidebar: '250px',
  sidebarSkinny: '50%',
  contentMaxWidth: '900px',
}
